import React, { useState, useEffect } from 'react';
import Accordian from '../common/components/Accordian/Accordian.js'
import facebook from "../common/media/facebook.svg";
import instagram from "../common/media/instagram.svg";
import twitter from "../common/media/twitter.svg";
import logo from "../common/media/cc_logo_white.svg";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import ProjectsList from "../common/components/Projects/ProjectsList";
import { Carousel } from 'react-responsive-carousel';
import { useHistory } from "react-router-dom";
import { convertToTonne } from "../common/util/unitConverter";
import { projects as getProjects } from '../common/api/projects'
import CountrySelect from "../common/components/CountrySelectionModal.js";
import Popover from "../common/components/popover/popover.js";
import FlightCalculator from "../common/components/offset/FlightCalculatorV2";
const Mission_Logo = "https://res.cloudinary.com/carbonclick/image/upload/v1632103065/Enterprise/SH%20Hotels/Mission_Logo_Final_cnf9oc.png";
const Leaf = "https://res.cloudinary.com/carbonclick/image/upload/v1632103086/Enterprise/SH%20Hotels/Leaf_gwo8tm.png";
import ImpactMobileView from "./ImpactMobileView";
import { getMerchantCodeWithPrefix } from '../../tools/MyCCMerchantLinkGenerator';
import { footerLinks } from '../common/util/uiConfigs/footerConfiguration.js';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'


const ClimateFriendlyTravellerPage = ({ fetchedImpact, ...props }) => {
    const [country, setCountry] = useState();
    const [isShowModal, setShowModal] = useState(false);
    const history = useHistory();
    const treeMetric = `An average tree captures about 20kg of carbon dioxide per year, and about 1 tonne over its lifetime. By funding projects that offset carbon emissions, we are having the same impact as ${fetchedImpact?.treeGrowthYears?.value?.toLocaleString()} trees have in one year.`;
    const [projects, setProjects] = useState();

    const getNightsFromCo2Amount = (impact) => {
        if(!impact?.value) return undefined;

        const tonnesOfCo2 = convertToTonne(impact.value, impact.unit);
        const nigts = tonnesOfCo2 / 0.03; //NZ multiplier // Jan said 30 kg 
        return nigts.toFixed(0);
    };

    const nightsOffset = fetchedImpact && getNightsFromCo2Amount(fetchedImpact.carbonOffsetImpact);

    useEffect(() => {
        getProjects(null,'SH_HOTELS').then(response => response.json()).then(data => setProjects(data));
    }, []);

    useEffect(() => {
        //trackAdditionalPageView('one-hotels')
    }, []);

    return (
        <div>
            <div className="p-3 bg-white center">
                <img style={{height: "50px"}} src={Mission_Logo} />
            </div>
            <div className="h-85vh w-100 position-relative img-cover hero-img vertical-align-parent" >
                <div className="container color-white text-left vertical-align">
                    <div className="mobile-hide">
                        <div className="mw-720px">
                            <h1 className="mb-4 text-shadow mt-0 color-white">We’re climate friendly for the future of our planet.</h1>
                            <h3 className="mb-3 text-shadow color-white">SH Hotels &amp; Resorts is consciously collaborating with CarbonClick to reduce the environmental impact of your travels and more.</h3>
                            <div className="mobile-hide mb-4">
                                <a className="btn btn-primary alt btn-lg" href="#FlightCalculator">Offset My Stay</a>
                            </div>
                        </div>

                        <div className="d-flex">
                            <h4 className="mr-2 mt-0 color-white">Powered By</h4>
                            <div>
                            <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 30 }} src={logo} /></a>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-show text-center">
                        <h2 className="mb-4 text-shadow mt-0 color-white">We’re climate friendly for the future of our planet.</h2>
                        <a className="btn btn-primary alt btn-lg font-bold" href="#FlightCalculator">Offset My Stay</a>
                    </div>
                </div>

                <div className="position-absolute bottom-abs w-100 pb-2 h-80px">
                    <a href="#content"><div className="arrow arrow-first"></div></a>
                </div>
            </div>
            <div className="mobile-show">
                <div className="bg-primary p-3 text-center">
                    <div className="d-flex w-fit center color-white">
                        <h5 className="mr-2 font-bold mt-1 mb-0 color-white">Powered By</h5>
                        <div>
                        <a target="_blank" href="https://www.carbonclick.com/"><img style={{ height: 30 }} src={logo} /></a>
                        </div>
                    </div>
                </div>
            </div>

            <div id="content" className="py-6">
                <div className="container text-center">
                    <div className="mb-3 center mw-720px">
                        <div className="mb-3">
                            <h2 className="font-bold">We are not a brand, we are a cause.</h2><br />
                            <h5 className="mb-3">This cause comes from a simple idea: the world around us is beautiful and we want to keep it that way. While each of our brands at SH Hotels & Resorts look at sustainability through a different lens, all of our properties strive to reduce our footprint while incorporating the beauty of nature into our guest experience.<br /><br />Just as nature is in a constant state of change, so is SH Hotels &amp; Resorts. We are constantly evolving, aiming to strengthen sustainability and grow our own community. We continue to take steps to make the best possible choices and vet every decision to ensure minimal impact.<br /><br />We partner with experts and entrepreneurs who share our values to implement improvements. We will always challenge industry standards and create new programs to keep our hotels striving toward greater and greater sustainability and environmental resiliency</h5>
                            <a className="btn btn-alt btn-lg font-bold"  target="_blank" href="https://www.1hotels.com/about-us/our-story">Our story</a>
                        </div>
                      
                    </div>
                    <div className="py-6 mobile-hide">
                        <div className="center bg-primary borders py-6 px-3" >
                            <h1 className="title font-bold">{`${nightsOffset ? Math.round(nightsOffset).toLocaleString() : ''}`}</h1>
                            <h5 className="font-bold" >Nights made climate positive</h5>
                        </div>

                        <div className="mw-800px center" style={{ marginTop: "-36px" }}>
                            <div className="row text-left m-0">
                                <div className="col-4 d-grid">
                                    <div className="center borders w-100">
                                        <div className="img-cover h-120px impact-community w-100">

                                        </div>
                                        <div className="px-2 py-4 font-bold">
                                            <h2>{fetchedImpact?.numberOfContributions?.value?.toLocaleString()}</h2>
                                            <p>Travellers have taken action</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4 d-grid">
                                    <div className="center borders w-100">
                                        <div className="img-cover h-120px impact-CO2 w-100">

                                        </div>
                                        <div className="px-2 py-4 font-bold">
                                            <h2>{fetchedImpact?.carbonOffsetImpact?.value  && Math.round(fetchedImpact.carbonOffsetImpact.value).toLocaleString()}</h2>
                                            <p>{fetchedImpact?.carbonOffsetImpact?.unit.toLowerCase()} of CO2 Offset</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-4 d-grid">
                                    <div className="center borders w-100">
                                        <div className="img-cover h-120px impact-trees w-100">

                                        </div>
                                        <div className="px-2 py-4 font-bold">
                                            <h2>{fetchedImpact?.treeGrowthYears?.value?.toLocaleString()}</h2>
                                            <p><span className="mr-2">Tree Growth Years</span>
                                                <Popover content={treeMetric} >
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 24 24" width="20">
                                                        <path d="M0 0h24v24H0z" fill="none" />
                                                        <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                                                    </svg>
                                                </Popover>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {fetchedImpact?.numberOfContributions  && <ImpactMobileView contributions={fetchedImpact.numberOfContributions}
                    carbonOffsetImpact={fetchedImpact.carbonOffsetImpact} treeGrowthYears={fetchedImpact.treeGrowthYears} 
                    nightsOffset={nightsOffset && Math.round(nightsOffset).toLocaleString()}/>}
            </div>

            <div className="bg-primary borders-y py-6" id="FlightCalculator">
                <div className="container text-center">
                    <div className="mb-4">
                        <h4><b>You’re already traveling more sustainably by staying with SH Hotels &amp; Resorts.</b></h4>
                        <p>Why not further reduce the environmental impact of your travel by offsetting your flight?</p>
                    </div>


                    <div className="center shadow-lg">
                        <FlightCalculator merchantCode={'SH_HOTELS'} />
                    </div>
     
                </div>
            </div>

            <div className="bg-secondary pt-5 pb-1">
                <div className="container text-center color-white">
                    <Carousel dynamicHeight={false} showThumbs={false} showArrows={false} showStatus={false} infiniteLoop={true} autoPlay={true}>

                        <div key="1" className="p-3 mb-4">
                            <div className="p-3">
                                <div className="center mw-600px">
                                    <div className="Quote">
                                        <h4 className='color-white'>&apos;&apos;As a frequent travel booker for my company, I find Climate Friendly Traveller easy to use to offset our travellers carbon. We know it&apos;s important to reduce the carbon footprint of our company when we travel both domestically and internationally.&apos;&apos;</h4>
                                        <p className="font-bold">Eilish</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div key="2" className="p-3 mb-4">
                            <div className="p-3">
                                <div className="center mw-600px">
                                    <div className="Quote">
                                        <h4 className='color-white' >&apos;&apos;Flying is an important part of my life, I fly for work, when visiting family and for holidays. I use Climate Friendly Traveller to easily offset my flight emissions to help me travel responsibly.&apos;&apos;</h4>
                                        <p className="font-bold">John</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div key="3" className="p-3 mb-4">
                            <div className="p-3">
                                <div className="center mw-600px">
                                    <div className="Quote">
                                        <h4 className='color-white' >&apos;&apos;Everyone needs to do their part to help fight climate change, A tool like Climate Friendly Traveller makes it quick and simple to remove our travel emissions without having to give up on flying.&apos;&apos;</h4>
                                        <p className="font-bold">Christopher</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Carousel>
                </div>
            </div>

            <div className="py-6">
                <div className="container text-center">
                    <div className="p-5 mb-5 borders">
                        <img src={Leaf} />
                        <h3>Live consciously beyond your travels with our sustainability tip sheet.</h3>
                        <p>Now that you’ve made the conscious decision to travel sustainably, we encourage you to continue the fight against climate change in your everyday life. Enjoy these tips to reduce your personal carbon footprint.</p>
                        <a className="btn btn-primary btn-lg font-bold" target="_blank" href="https://www.carbonclick.com/wp-content/uploads/2020/02/CarbonClick_Tips.pdf">Download the Tipsheet</a>
                    </div>
<div className="row">
    <div className="col-md-4 mb-3">
        <div className="mb-3">
            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2 22.9998L20.2 29.9998L34.2 15.9998" stroke="black" strokeWidth="2.8" strokeLinecap="round"/>
                <path d="M23 44C34.598 44 44 34.598 44 23C44 11.402 34.598 2 23 2C11.402 2 2 11.402 2 23C2 34.598 11.402 44 23 44Z" stroke="#E4EBCC" strokeWidth="2.8"/>
            </svg>
        </div>
        <h4 className="font-bold">Convert your rewards to climate credits</h4>
        <p>Support the worlds best projects that fight climate change by converting your loyalty rewards to climate credits.</p>
    </div>
    <div className="col-md-4 mb-3">
    <div className="mb-3">
            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2 22.9998L20.2 29.9998L34.2 15.9998" stroke="black" strokeWidth="2.8" strokeLinecap="round"/>
                <path d="M23 44C34.598 44 44 34.598 44 23C44 11.402 34.598 2 23 2C11.402 2 2 11.402 2 23C2 34.598 11.402 44 23 44Z" stroke="#E4EBCC" strokeWidth="2.8"/>
            </svg>
        </div>
        <h4 className="font-bold">Resiliency &amp; Ongoing Performance Improvement</h4>
        <p>Through initiatives like our plastic reduction program and electric car activations, we continue to find ways to evolve.</p>
    </div>
    <div className="col-md-4 mb-3">
    <div className="mb-3">
            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2 22.9998L20.2 29.9998L34.2 15.9998" stroke="black" strokeWidth="2.8" strokeLinecap="round"/>
                <path d="M23 44C34.598 44 44 34.598 44 23C44 11.402 34.598 2 23 2C11.402 2 2 11.402 2 23C2 34.598 11.402 44 23 44Z" stroke="#E4EBCC" strokeWidth="2.8"/>
            </svg>
        </div>
        <h4 className="font-bold">Organisational partnerships</h4>
        <p>We organize volunteer activities and paid volunteer days for our teams.</p>
    </div>
</div>
<div className="row">
    <div className="col-md-4 mb-3">
        <div className="mb-3">
            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2 22.9998L20.2 29.9998L34.2 15.9998" stroke="black" strokeWidth="2.8" strokeLinecap="round"/>
                <path d="M23 44C34.598 44 44 34.598 44 23C44 11.402 34.598 2 23 2C11.402 2 2 11.402 2 23C2 34.598 11.402 44 23 44Z" stroke="#E4EBCC" strokeWidth="2.8"/>
            </svg>
        </div>
        <h4 className="font-bold">Environmental Design</h4>
        <p>We have implemented a wide range of energy, WATER, and environmental design strategies to keep our footprint small.</p>
    </div>
    <div className="col-md-4 mb-3">
    <div className="mb-3">
            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2 22.9998L20.2 29.9998L34.2 15.9998" stroke="black" strokeWidth="2.8" strokeLinecap="round"/>
                <path d="M23 44C34.598 44 44 34.598 44 23C44 11.402 34.598 2 23 2C11.402 2 2 11.402 2 23C2 34.598 11.402 44 23 44Z" stroke="#E4EBCC" strokeWidth="2.8"/>
            </svg>
        </div>
        <h4 className="font-bold">Human Health &amp; Wellbeing</h4>
        <p>From air and water filtration systems, to biophilic design principles and the use of natural materials, we place health and wellness at the center of design.</p>
    </div>
    <div className="col-md-4 mb-3">
    <div className="mb-3">
            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2 22.9998L20.2 29.9998L34.2 15.9998" stroke="black" strokeWidth="2.8" strokeLinecap="round"/>
                <path d="M23 44C34.598 44 44 34.598 44 23C44 11.402 34.598 2 23 2C11.402 2 2 11.402 2 23C2 34.598 11.402 44 23 44Z" stroke="#E4EBCC" strokeWidth="2.8"/>
            </svg>
        </div>
        <h4 className="font-bold">Food &amp; Beverage Responsibility</h4>
        <p>We believe that all food should be good, clean and fair; natural resources should be protected for future generations.</p>
    </div>
</div>
                    
                </div>
            </div>


            <div className="p-5 mb-5 bg-grain img-cover">
                <div className="center">
                    <h3>Feeling inspired to take more action?</h3>
                    <p>Start reducing your personal carbon footprint now!</p>
                    <a className="btn btn-primary btn-lg font-bold" target="_blank" href={`https://my.carbon.click/${getMerchantCodeWithPrefix(props.merchantCode)}/subscribe`}>Check Out Our Plans</a>
                </div>
            </div>


            {fetchedImpact?.projects && <>
                <div className="py-6">
                    <div className="container text-center">
                        <div className="mb-5 center mw-600px">
                            <h3 className="font-bold">Here are the projects that are Fighting Climate Change</h3>
                            <h5>Our program supports high quality and trusted projects around the world that share our mission of fighting climate change and protecting the planet.</h5>
                        </div>
                        <div className="text-left mobile-text-center">
                            <ProjectsList title={null} projects={projects} />
                        </div>
                    </div>
                </div>
            </>}
{/*

            <div className="py-6">
                <div className="container text-center">
                    <div className="mb-5 center mw-600px">
                        <h3 className="font-bold">Here are the projects that are Fighting<br/>Climate Change</h3>
                        <h5>Our programme only supports the highest quality carbon offsetting projects around the world, to make a meaningful climate impact.</h5>
                    </div>
                    <div className="text-left mobile-text-center">
                        <section className="projects-baskets-section">
                            <div>
                                <div className="project-basket mb-4">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="h-240px w-100 img-cover" style={{ backgroundImage: "url('https://res.cloudinary.com/carbonclick/image/upload/v1605150528/Project%20Baskets/Doha/Australia_i0vxjz.png')" }}>
                                            </div>
                                        </div>
                                        <div className="col-6 py-3">
                                            <h4 className="font-bold">Restoring the Outback</h4>
                                            <h5>Western Australia</h5>
                                            <p>This strategic program aims  to build and secure native seed and plant supply for restoration after the devastating Black Summer bushfires.</p>
                                            <a target="_blank" href="https://www.carbonclick.com/how-it-works/projects/" className="font-bold color-primary">Learn More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="project-basket mb-4">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="h-240px w-100 img-cover" style={{ backgroundImage: "url('https://res.cloudinary.com/carbonclick/image/upload/v1605150529/Project%20Baskets/Doha/USA_echrvt.png')" }}>
                                            </div></div>
                                        <div className="col-6 py-3">
                                            <h4 className="font-bold">Redwood Conservation</h4>
                                            <h5>USA</h5>
                                            <p>These incredible trees are the tallest living things on Earth. But most of them have been felled over the last 150 years. The remaining trees on the west coast of America are under threat from forest fire, drought and a changing climate.</p>
                                            <a target="_blank" href="https://www.carbonclick.com/how-it-works/projects/" className="font-bold color-primary">Learn More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="project-basket mb-4">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="h-240px w-100 img-cover" style={{ backgroundImage: "url('https://res.cloudinary.com/carbonclick/image/upload/v1605150528/Project%20Baskets/Doha/Morocco_cwcneo.png')" }}>
                                            </div>
                                        </div>
                                        <div className="col-6 py-3">
                                            <h4 className="font-bold">Solar Power</h4>
                                            <h5>Morocco</h5>
                                            <p>This ambitious project aims to develop renewable energy to meet 15 percent of the country’s energy demand and to increase the use of energy-saving methods.</p>
                                            <a target="_blank" href="https://www.carbonclick.com/how-it-works/projects/" className="font-bold color-primary">Learn More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="project-basket mb-4">
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="h-240px w-100 img-cover" style={{ backgroundImage: "url('https://res.cloudinary.com/carbonclick/image/upload/v1605150528/Project%20Baskets/Doha/Cambodia_obrbuq.png')" }}>
                                            </div>
                                        </div>
                                        <div className="col-6 py-3">
                                            <h4 className="font-bold">Biosand Water Filters</h4>
                                            <h5>Cambodia</h5>
                                            <p>This project is builds and installs biosand water filters, household units that produce clean drinking water directly from contaminated sources.</p>
                                            <a target="_blank" href="https://www.carbonclick.com/how-it-works/projects/" className="font-bold color-primary">Learn More</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>


            projects && <>
                <div className="py-6">
                    <div className="container text-center">
                        <div className="mb-5 center mw-600px">
                            <h3 className="font-bold">Support Projects That Fight<br />Climate Change</h3>
                            <p>CarbonClick supports only the highest quality carbon offsetting projects around the world, to bring you peace of mind and results.</p>
                        </div>
                        <div className="text-left mobile-text-center">
                            <ProjectsList title={null} projects={projects} />
                        </div>
                    </div>
                </div>
            </>*/}

            <div className="py-6 mobile-p-0">
                <div className="container text-center">
                    <h3 className="font-bold mb-4">Programme FAQs</h3>

                    <div className="mb-3 center text-left mw-800px">
                        <Accordian title={"What are carbon credits?"} >A carbon credit is mechanism used to measure and support projects that fight climate change. For every tonne of CO2 that a project manages to absorb or otherwise reduce, a carbon credit is issued. Carbon credits are certified by international standards and held in registries like the Gold Standard registry (international credits) and can be purchased to reduce the carbon impact of an initiative or activity.</Accordian>
                        <Accordian title={"How are flight emissions calculated?"}>CarbonClick calculates the carbon emissions of flights through the use of the IATA emissions factors, an international standard in emissions calculations.<br /><br />A point of contention in calculating the emissions of flights is ‘Radiative Forcing’, this related to the effects vapours and aerosols have when released in high atmosphere in forming clouds, due to the ongoing debate in the scientific community CarbonClicks calculations do not currently include the effects of radiative forcing.</Accordian>
                        <Accordian title={"Who are CarbonClick?"} >CarbonClick is a New Zealand company that exists to reverse climate change, CarbonClick empowers businesses and their customers to tackle climate change, by making carbon offsets simple, trustworthy and cost effective. Building a happier and more sustainable future for everyone.</Accordian>
                        <Accordian title={"Where does the money go?"} >The money paid to CarbonClick for carbon credits goes towards certified carbon offset projects that have met the highest standards. The funds are distributed amongst carbon offset suppliers carrying out the projects and CarbonClick takes a margin on the carbon credits for sourcing projects, quality assurance, administration and transaction fees.</Accordian>
                    </div>

                    <a href={footerLinks.faq} target="_blank" rel="noopener noreferrer" className="btn btn-alt btn-lg font-bold" >View All</a>
                    <div className="mobile-show py-5"></div>

                </div>
            </div>


            {/*<div className="bg-green-light py-6">
                <div className="container text-center">
                    <div className="mb-5 center mw-600px">
                        <h2 className="font-light">Make a difference in fighting climate change</h2>
                        <p>Purchase a subscription to make an ongoing, traceable difference. We&apos;ll show you how your positive impacts grow each month.</p>
                    </div>

                    country && <PlansList
                        selectedPlan={selectedPlan}
                        onSelectedPlanChange={setSelectedPlan}
                        planChosen={planChosen}
                        country={country}
                        setLocationModalVisible={setShowModal}
                    />}
                </div>
            </div>*/}


            <div className="w-100 img-cover footer-img py-6" >
                <div className="container color-white py-5">
                    <p><b>Powered by</b></p>
                    <div className="d-flex">
                        <div>
                            <a href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">
                                <img style={{ height: 30 }} className="footer-logo" src={logo} alt="carbonclick" />
                            </a>
                        </div>
                        <div className="right">
                            <div>
                                <a href={footerLinks?.facebook} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={facebook} alt="carbonclick" />
                                </a>
                                <a href={footerLinks?.instagram} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={instagram} alt="carbonclick" />
                                </a>
                                <a href={footerLinks?.twitter} target="_blank" rel="noopener noreferrer">
                                    <img style={{ width: 30 }} src={twitter} alt="carbonclick" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <hr className="mb-4" />

                    <div className="row">
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.carbonclick} target="_blank" rel="noopener noreferrer">How it works</a></div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.aboutCarbonClick} target="_blank" rel="noopener noreferrer">About CarbonClick</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.termsAndConditions} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a></div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.privacyPolicy} target="_blank" rel="noopener noreferrer">Privacy policy</a></div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div>
                                <div className="mb-3"><a className="color-white" href={footerLinks?.faq} target="_blank" rel="noopener noreferrer">FAQs</a></div>
                                <div className="mb-3"><a className="color-white" href="mailto:support@carbonclick.com" target="_blank" rel="noopener noreferrer">support@carbonclick.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <CountrySelect isShowModal={isShowModal} setShowModal={setShowModal} country={country} setCountry={setCountry}></CountrySelect>
        </div>
    )
}


export default ClimateFriendlyTravellerPage;